module.exports = __webpack_public_path__ + "files/0f9151eb468878c384d0ebc3010cdac7.png";